import React from 'react'

import { Container, Row, Col } from 'react-bootstrap';
import { useGetSukariProductsQuery } from '../../slices/productsApiSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';

import Meta from '../../components/Meta';
import ShoppingProduct from '../../components/ShoppingProduct';

const SITE = 'https://tamratdates.com';

// FAQ content (Arabic = the prerendered/primary language; English alongside).
const FAQ_AR = [
  { q: 'أين يُزرع التمر السكري؟', a: 'يُزرع التمر السكري غالباً في منطقة القصيم وسط السعودية، المعروفة بجودة تمورها وحلاوتها العالية.' },
  { q: 'ما الفرق بين السكري الرطب والناشف؟', a: 'الرطب أطرى وأعلى في الرطوبة ويُؤكل طازجاً، بينما الناشف أكثر تماسكاً وأطول في مدة الحفظ.' },
  { q: 'هل التمر السكري مناسب للإهداء؟', a: 'نعم، لونه الذهبي الفاتح وقوامه الطري يجعلانه من أجمل خيارات الإهداء في علبة فاخرة.' },
  { q: 'كيف أحفظ التمر السكري طازجاً؟', a: 'احفظه في مكان بارد وجاف، أو في الثلاجة للحفاظ على طراوته لفترة أطول.' },
];
const FAQ_EN = [
  { q: 'Where are Sukari dates grown?', a: 'Sukari dates are grown mainly in the Qassim region of central Saudi Arabia, known for the quality and sweetness of its dates.' },
  { q: "What's the difference between soft (rutab) and dry Sukari?", a: 'Rutab Sukari is softer and higher in moisture and eaten fresh, while the drier form is firmer and keeps for longer.' },
  { q: 'Are Sukari dates good for gifting?', a: 'Yes — their light-golden colour and soft texture make them a beautiful choice for premium gift boxes.' },
  { q: 'How do I store Sukari dates?', a: 'Keep them in a cool, dry place, or refrigerate to preserve their softness for longer.' },
];

function SukariDates() {

  const { t , i18n } = useTranslation();
  const en = i18n.language === 'en';

    const { data, isLoading, error } = useGetSukariProductsQuery();

  const url = `${SITE}/sukari-date`;
  const faq = en ? FAQ_EN : FAQ_AR;
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: en ? 'Home' : 'الرئيسية', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: en ? 'Sukari Dates' : 'تمر سكري', item: url },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

    if(isLoading) {
      return(
      <div>
   <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
   <Skeleton width={150} />
   </div>

      <h1 className="title">
         <Skeleton width={150} />
      </h1>

        <Row className="py-5">

        <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>
                <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>
                <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>
                <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>
                <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>
                <Col sm={4} className="mb-2">
                  <Skeleton height={250} width={350} />
                </Col>

        </Row>

    </div>
      )
    }

  return (
    <div>
      {en ? (
        <>
          <Meta
            title={'Sukari Dates — Premium Qassim Sukari | Tamrat'}
            description={'Buy premium Sukari dates online from Tamrat — soft, golden, caramel-sweet dates from the Qassim region. Fast delivery across Saudi Arabia, free over 250 SAR.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>Home</span></Link>
            <FaAngleRight />
            <span style={{color:'#7C9D64'}}>Sukari Date</span>
          </div>
        </>
      ) : (
        <>
          <Meta
            title={'تمر سكري القصيم الأصلي — طبيعي وطازج | تمرات'}
            description={'اشترِ تمر سكري فاخر من تمرات: ذهبي، طري، وحلاوة كراميلية من القصيم. توصيل سريع لكل مناطق السعودية وشحن مجاني للطلبات فوق ٢٥٠ ر.س.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>الرئيسية</span></Link>
            <FaAngleLeft />
            <span style={{color:'#7C9D64'}}>تمر السكري</span>
          </div>
        </>
      )}

      <h1 className="title">{t('sukariTitle')}</h1>
      <Container>
        <Row className="py-5">
        { error ? (
        <div>{error?.data.message || error.error}</div>
      ) : (
        data.products.map((product) => (
          <Col sm={4} key={product.id} className='mb-4 p-4'>
         <ShoppingProduct product={product} />
        </Col>
         ))
             )}
        </Row>
      </Container>

      {/* Variety explainer — EEAT content (accurate, no fabricated claims) */}
      <Container className="pb-5" dir={en ? 'ltr' : 'rtl'} style={{ maxWidth: 900, lineHeight: 1.9, color: '#3d3d3d' }}>
        {en ? (
          <div>
            <h2 style={{ color: '#7C9D64' }}>What is Sukari?</h2>
            <p>Sukari is one of Saudi Arabia's most popular and beloved dates. Grown mainly in the <strong>Qassim</strong> region, it's known for its light-golden colour, soft melt-in-the-mouth texture, and high, caramel-like sweetness. It can be enjoyed fresh (rutab) or drier, and remains an everyday favourite for many families.</p>
            <h2 style={{ color: '#7C9D64' }}>How to enjoy Sukari dates</h2>
            <ul>
              <li>With Arabic coffee — the classic gesture of hospitality.</li>
              <li>As a quick bite between meals or before a workout for natural energy.</li>
              <li>At breakfast, or paired with milk and nuts.</li>
              <li>As an elegant gift in a premium box.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>Nutrition</h2>
            <p>Sukari dates are a natural source of energy, fibre, potassium and natural sugars. <em>Values are approximate and vary by size and ripeness; for any specific diet, consult a specialist.</em></p>
            <h2 style={{ color: '#7C9D64' }}>Who it's for</h2>
            <p>For lovers of soft, intensely sweet dates, anyone looking for a natural alternative to sweets, and for hospitality and gifting.</p>
            <h2 style={{ color: '#7C9D64' }}>Frequently asked questions</h2>
            {FAQ_EN.map((f, i) => (
              <div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>
            ))}
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#7C9D64' }}>ما هو التمر السكري؟</h2>
            <p>التمر السكري من أشهر أنواع التمور السعودية وأكثرها حضوراً على الموائد. يُزرع غالباً في منطقة <strong>القصيم</strong>، ويتميّز بلونه الذهبي الفاتح وقوامه الطري الذي يكاد يذوب، وحلاوته العالية ذات النكهة الكراميلية. يُؤكل طازجاً (رطباً) أو ناشفاً، ويبقى المفضّل اليومي لكثير من العائلات.</p>
            <h2 style={{ color: '#7C9D64' }}>كيف تستمتع بالتمر السكري؟</h2>
            <ul>
              <li>مع القهوة العربية كضيافة لا تُردّ.</li>
              <li>قضمة سريعة بين الوجبات أو قبل التمرين لطاقة طبيعية.</li>
              <li>في الإفطار أو مع الحليب والمكسرات.</li>
              <li>هدية أنيقة في علبة فاخرة.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>القيمة الغذائية</h2>
            <p>التمر السكري مصدر طبيعي للطاقة والألياف والبوتاسيوم والسكريات الطبيعية. <em>القيم تقريبية وتختلف حسب الحجم ودرجة النضج؛ ولأي نظام غذائي خاص يُنصح باستشارة مختص.</em></p>
            <h2 style={{ color: '#7C9D64' }}>لمن يناسب؟</h2>
            <p>لمحبّي التمر الطري شديد الحلاوة، وللباحثين عن بديل طبيعي للحلويات، وللضيافة والإهداء.</p>
            <h2 style={{ color: '#7C9D64' }}>الأسئلة الشائعة</h2>
            {FAQ_AR.map((f, i) => (
              <div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>
            ))}
          </div>
        )}
      </Container>
    </div>
  )
}

export default SukariDates
